// CopyCouponPatientPayGpiList.js  
import React, { useState, useEffect, useMemo,useRef } from 'react';  
import { useLocation } from 'react-router-dom';  
import useCustomNavigate from '../../common_nextgen/common_components/Navigation/NextGenNavigation';  
import Form from '../../common_nextgen/common_components/form/Form';  
import { PRICE_SCHEDULE_MODES, isAddMode, isEditMode, isReadOnlyMode } from '../../common_nextgen/utils/Constants';  
import { useAxios } from '../../common_nextgen/axios/AxiosHelper';  
import { useToast } from '../../common_nextgen/hooks/ToastContext';  
import FunctionKeys from '../../common_nextgen/common_components/FunctionKeys/FunctionKeys';  
import { formFields } from './CopyCouponPatientPayGpiListConfig';  
import { screenInfo } from './CopyCouponPatientPayGpiListConfig';  
import { ROUTE_PATHS } from '../../common_nextgen/utils/Constants'; 
  
const CopyCouponPatientPayGpiList = ({ mode }) => {  
    const location = useLocation();  
    const { state: stateVal } = location;
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    const { selectedPriceSchedules = [], previousScreen = ROUTE_PATHS.PATIENT_PAY_SCHEDULE, currentIndex: initialIndex = 0 } = currentState;  
   
    const navigateToPage = useCustomNavigate();  
    const [currentIndex, setCurrentIndex] = useState(initialIndex);  
    const [currentMode, setCurrentMode] = useState(mode);  
    const [constraintErrors, setConstraintErrors] = useState([]);  
    const toast = useToast();  
    const { axios_helper_no_header } = useAxios();
  const initialFormData = useMemo(() => {
    const { cpfGpiListName: dtlCpfGpiListName = "", cpfGpiListDescription: dtlCpfGpiListDescription = "" } = selectedPriceSchedules[currentIndex];
    return { dtlCpfGpiListName, dtlCpfGpiListDescription,dtlToListId:"",dtlToDescription:"" }  }, [selectedPriceSchedules, currentIndex]
  ) 
   
  const lastValidOpcScheduleName = useRef("");
    const handleBack = () => {  
        const lastScheduleName = selectedPriceSchedules[currentIndex]?.cpfGpiListName;
        if (lastScheduleName) {
          lastValidOpcScheduleName.current = lastScheduleName;
        }
        const updatedParamsData = {
          ...currentState.paramsData,
          cpfGpiListName: lastValidOpcScheduleName.current,
        };
        if (currentIndex < selectedPriceSchedules.length - 1) {  
            setCurrentIndex(currentIndex + 1);  
        } else {  
            navigateToPage(previousScreen,  [
                ...previousState,
                {
                  ...currentState,
                  paramsData: updatedParamsData,
                  currentIndex: currentIndex,
                },
              ]);   
        }  
    };  
  
    const getPageTitle = () => {  
        const { screenTitle, screenNumber } = screenInfo;  
        return (  <>
            <span className="title">{screenTitle}</span>  
            <span>{'-'}</span>  
            <span className="screen-number">{screenNumber}</span> 
            </> 
        );  
    };  
  
    const submitForm = async (dataForSubmission) => {  
        const data = { ...dataForSubmission, screenNumber: screenInfo.screenNumber };  
        const url = 'api/couponPatPayGpiList/copy';  
        const verb = 'POST';  
        try {  
            const { responseStatus } = await axios_helper_no_header(verb, url, data, null);  
            toast.current.show({ severity: "success", summary: "", detail: responseStatus.message, life: 3000 });  
            selectedPriceSchedules[currentIndex].cpfGpiListName =
      data.dtlToListId;
        } catch (error) {  
            const { responseStatus: { displayErrorFields = null, message } } = error.data;  
            if (!displayErrorFields) {  
                toast.current.show({ severity: "error", summary: "", detail: message, life: 3000 });  
            } else {  
                setConstraintErrors(displayErrorFields);  
            }  
        }  
    };  
  
    const [keyFunc, keyName] = useMemo(() => {  
        const keyFunc = {};  
        const keyName = {};  
  
        keyFunc['F12'] = handleBack;  
        keyName['F12'] = 'Back';  
  
        return [keyFunc, keyName];  
    }, [currentIndex]);  
  
  
    return (  
        <div className="grid container">  
            <div className="col col-12">  
                <FunctionKeys keyFunc={keyFunc} keyName={keyName} />  
            </div>  
            <div className="col col-12">  
                <h1>{getPageTitle()}</h1>  
            </div>  
            <div className="col col-12">  
                <Form  
                    formData={initialFormData}  
                    formFields={formFields}  
                    mode={mode}  
                    submitFormData={submitForm}  
                    constraintErrors={constraintErrors}  
                />  
            </div>  
        </div>  
    );  
};  
  
export default CopyCouponPatientPayGpiList;  
